<template>
  <div id="fee-calculator">
    <div class="datatable-form__header">
      <div class="datatable-form__input form-group">
        <el-select placeholder="Select Semester" v-model="selectedSemester" class="ddlSearchStatus">
          <el-option v-for="option in semesterList" :key="option.PK_Semester_ID" :label="option.SMT_Code" :value="option.PK_Semester_ID"> </el-option>
        </el-select>
      </div>
      <div class="datatable-form__input form-group">
        <el-select placeholder="Select Class" :disabled="classList.length === 0" v-model="selectedClass" class="ddlSearchStatus">
          <el-option v-for="option in classList" :key="option.PK_Class_ID" :label="`${option.CLS_ClassName} (${option.CLS_Batch})`" :value="option.PK_Class_ID">
          </el-option>
        </el-select>
      </div>
      <div class="datatable-form__input form-group">
        <el-select placeholder="Select School Term" v-model="selectedTerm" class="ddlSearchStatus">
          <el-option v-for="option in semesterDetailList" :key="option.PK_SEMD_ID" :label="option.SEMD_DetailName" :value="option.SEMD_DetailName"> </el-option>
        </el-select>
      </div>
      <div class="datatable-form__input form-group">
        <el-select placeholder="Select Payment Plan" :disabled="paymentPlanList.length === 0" v-model="selectedPaymentPlan" class="ddlSearchStatus">
          <el-option
            v-for="option in paymentPlanList"
            :key="option.PK_Course_Fee_Scheme_ID"
            :label="option.PPM_Fee_Scheme_Name"
            :value="option.PK_Course_Fee_Scheme_ID"
          >
          </el-option>
        </el-select>
      </div>
      <div class="datatable-form__input form-group">
        <el-input v-model="selectedWeeks" type="number" placeholder="Number of Weeks">
          <template slot="append">WEEKS</template>
        </el-input>
      </div>
    </div>
    <data-tables
      v-if="paymentDetails.length > 0 && selectedTerm"
      :data="[selectedTermCourseFee]"
      :pagination-props="{ pageSizes: [1000] }"
      style="max-width: 800px; margin: 0 auto"
    >
      <el-table-column
        v-for="item in [
          { prop: 'PPD_Payee_Name', label: 'Description' },
          { prop: 'PPD_CalCategory', label: 'Category' },
          { prop: 'PPD_Amount', label: 'Amount' },
        ]"
        :prop="item.prop"
        :label="item.label"
        :key="item.prop"
      >
      </el-table-column>
    </data-tables>
    <div style="margin-top: 10px; font-size: 1.25rem" v-if="paymentPlan && paymentDetails.length > 0 && selectedTerm">
      <div>Prorated School Fees:</div>
      <span v-text="formula"></span> = $<span v-text="formulaResult"></span>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import DataSource from '../data/datasource'
import { debounce } from 'throttle-debounce'
import moment from 'moment'

export default {
  name: 'FeeCalculator',
  components: {},
  data() {
    return {
      selectedSemester: null,
      selectedClass: null,
      selectedTerm: null,
      selectedPaymentPlan: null,
      semesterList: [],
      classList: [],
      semesterDetailList: [],
      paymentPlanList: [],
      paymentDetails: [],
      selectedWeeks: 1,
    }
  },
  computed: {
    paymentPlan() {
      return this.paymentPlanList.find(x => x.PK_Course_Fee_Scheme_ID === this.selectedPaymentPlan)
    },
    formula() {
      const fee = this.selectedTermCourseFeeAmount
      const formula = `${fee} * ${this.selectedWeeks}/${this.selectedTermWeeks}`
      return formula
    },
    formulaResult() {
      return eval(this.formula).toFixed(2)
    },
    selectedTermWeeks() {
      if (!this.selectedTerm) return null
      const term = this.semesterDetailList.find(x => x.SEMD_DetailName === this.selectedTerm)
      return moment(term.SEMD_ToDate).diff(moment(term.SEMD_FromDate), 'weeks') + 1
    },
    selectedTermCourseFee() {
      const paymentDetail = this.paymentDetails.find(
        x => x.PPD_CalCategory === 'Course Fees' && x.PPD_Payee_Name.toUpperCase().includes(this.selectedTerm.toUpperCase()),
      )
      if (!paymentDetail) {
        alert('Failed to match term to the payment plan')
        return null
      }
      return paymentDetail
    },
    selectedTermCourseFeeAmount() {
      return this.selectedTermCourseFee ? this.selectedTermCourseFee.PPD_Amount : 0
    },
  },
  watch: {
    selectedSemester: function () {
      this.selectedClass = null
      this.throttledUpdateOptions()
    },
    selectedClass: function () {
      this.throttledUpdateOptions()
    },
  },
  async mounted() {
    this.updateOptions()
    this.throttledUpdateOptions = debounce(100, this.updateOptions)
  },
  methods: {
    async updateOptions() {
      const data = { school: Cookies.get('schoolSession'), semester: this.selectedSemester, class: this.selectedClass }
      const response = await DataSource.shared.callWebService('/controller/Fee_Calculator.asmx/api', data, 'GET', false)
      if ('semesters' in response) {
        this.semesterList = response.semesters
      }
      if ('classes' in response) {
        this.classList = response.classes
      }
      if ('payment_plans' in response) {
        this.paymentPlanList = response.payment_plans
        if (this.paymentPlanList.length > 0) {
          this.selectedPaymentPlan = this.paymentPlanList[0].PK_Course_Fee_Scheme_ID
        }
      } else if (data.semester && data.class) {
        alert('Failed to find a matching payment plan.')
      }
      if ('semester_details' in response) {
        this.semesterDetailList = response.semester_details
      }
      if ('payment_plan_details' in response && this.selectedPaymentPlan) {
        this.paymentDetails = response.payment_plan_details.filter(x => x.FK_Course_Fee_Scheme_ID === this.selectedPaymentPlan)
      }
    },
  },
}
</script>

<style>
#fee-calculator .datatable-form__header {
  display: grid;
  gap: 10px;
}
#fee-calculator .el-input-group {
  width: 400px;
}
#fee-calculator .el-select,
#fee-calculator .el-input__inner {
  width: 100%;
  color: white;
}
#fee-calculator .pagination-bar {
  display: none;
}
#fee-calculator .el-input-group__append {
  background-color: #5f71e8;
  border-color: #5f71e8;
  color: white;
}
</style>
